
import { getDentalCorpBackend } from "../commons/backend/dentalCorpBackendProxy";
import { STATUS } from "../components/AiSkuMapping/constants";
import {
  REJECT_AI_SKU_MAPPING,
  UPDATE_AI_SKU_MAPPING,
  APPROVE_AI_SKU_MAPPING,
  FETCH_RECOMMENDED_AI_SKU_MAPPINGS,
  DECREMENT_UNREVIEWED_RECOMMENDATIONS_COUNT
} from "./types";
const dentalCorpBackend = getDentalCorpBackend();

export const fetchRecommendedAiSkuMappings = (pageNumber, pageSize) => {
  return async (dispatch, getState) => {
    let response = await dentalCorpBackend.fetchRecommendedAiSkuMappings(
      getState(),
      pageNumber,
      pageSize,
      dispatch,
    );
    if (response !== null && response !== undefined) {
      dispatch({
        type: FETCH_RECOMMENDED_AI_SKU_MAPPINGS,
        payload: response.response,
      });
      return response;
    }
    return null;
  };
};

export const approveAiSkuMappingRecommendation = (id, body) => {
  return async (dispatch, getState) => {
    let response = await dentalCorpBackend.approveAiSkuMappingRecommendation(
      getState(),
      body,
      dispatch,
    );
    if (response !== null && response !== undefined) {
      dispatch({ type: APPROVE_AI_SKU_MAPPING, payload: id });
      return response;
    }
    return null;  
  };
};

export const rejectAiSkuMappingRecommendation = (id, body) => {
  return async (dispatch, getState) => {
    let response = await dentalCorpBackend.rejectAiSkuMappingRecommendation(
      getState(),
      body,
      dispatch,
    );
    if (response !== null && response !== undefined) {
      dispatch({ type: REJECT_AI_SKU_MAPPING, payload: id });
      return response;
    }
    return null;
  };
};

export const updateAiSkuMappingRecommendation = (id, data) => {
  return async (dispatch, getState) => {
    const { status, ...body } = data;
    if (status === STATUS.MAPPED) {
      const response =
        await dentalCorpBackend.approveAiSkuMappingRecommendation(
          getState(),
          body,
          dispatch,
        );
      if (response !== null && response !== undefined) {
        dispatch({ type: UPDATE_AI_SKU_MAPPING, payload: { id, data } });
        return response;
      }
    } else if (status === STATUS.UNMAPPED) {
      const response = await dentalCorpBackend.rejectAiSkuMappingRecommendation(
        getState(),
        body,
        dispatch,
      );
      if (response !== null && response !== undefined) {
        dispatch({ type: UPDATE_AI_SKU_MAPPING, payload: { id, data } });
        return response;
      }
    }
    return null;
  };
};

export const decrementUnreviewedRecommendationsCount = () => {
  return async (dispatch) => {
    dispatch({ type: DECREMENT_UNREVIEWED_RECOMMENDATIONS_COUNT });
  };
};